/**
 * CMS merge tag catalog — subset of email merge tags relevant for website blocks.
 * Used by the VariablePicker in the Visual Builder.
 */

export interface CmsMergeTag {
  key: string;      // dot-path, e.g. "customer.firstName"
  label: string;    // human-readable label
  example: string;  // sample value for preview
}

export interface CmsMergeTagGroup {
  id: string;
  name: string;
  icon: string;     // lucide icon name or emoji
  tags: CmsMergeTag[];
}

export const CMS_MERGE_TAG_GROUPS: CmsMergeTagGroup[] = [
  {
    id: 'customer',
    name: 'Customer',
    icon: '👤',
    tags: [
      { key: 'customer.firstName', label: 'First name', example: 'Jane' },
      { key: 'customer.lastName', label: 'Last name', example: 'Doe' },
      { key: 'customer.fullName', label: 'Full name', example: 'Jane Doe' },
      { key: 'customer.email', label: 'Email', example: 'jane@example.com' },
    ],
  },
  {
    id: 'loyalty',
    name: 'Loyalty',
    icon: '⭐',
    tags: [
      { key: 'loyalty.pointsBalance', label: 'Points balance', example: '1,250' },
      { key: 'loyalty.tierCode', label: 'Tier code', example: 'gold' },
      { key: 'loyalty.tierName', label: 'Tier name', example: 'Gold' },
      { key: 'loyalty.lifetimePoints', label: 'Lifetime points', example: '4,800' },
    ],
  },
];

/** Wrap a key in double-braces: "customer.firstName" → "{{customer.firstName}}" */
export function toPlaceholder(key: string): string {
  return `{{${key}}}`;
}

/** All tags flat for quick lookup */
export const CMS_MERGE_TAGS_FLAT: CmsMergeTag[] = CMS_MERGE_TAG_GROUPS.flatMap((g) => g.tags);
